export enum ProgressLineStepType {
    DRAFT = 'DRAFT',
    SENT_FOR_INTERNAL_APPROVAL = 'SENT_FOR_INTERNAL_APPROVAL',
    INTERNAL_APPROVED = 'INTERNAL_APPROVED',
    SENT = 'SENT',
    CONFIRM = 'CONFIRM',
    PAID = 'PAID'
}
